import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { formRegistry } from "../formRegistry";
import { CNYProps } from "../../../../../types/walletTypes";

const ReviewV2 = ({ handlePrevious }: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);
  const currentStep = "review";
  const method = getSavedData?.paymentMethod;

  const CurrentStepComponent = formRegistry[currentStep]?.[method];


  if (!CurrentStepComponent) {
    return null
  }

  return (
    <CurrentStepComponent
      handlePrevious={handlePrevious}
    />
  );
};

export default ReviewV2;
